import { v4 as uuidv4 } from 'uuid'
import { CountryItem } from '../reducers/types'

export const generateExternalTransferId = () => {
  const uuid = uuidv4()
  const trimId = uuid.slice(9)
  return `Apex-UI-${uuid[0]}${trimId}`
}

export const getCountryCode = (countryList: CountryItem[], countryName: string = 'United States') => {
  const defaultCode = 'USA'

  if (countryList.length) {
    const countryObj = countryList.find(
      (country) => country.isoName?.toLocaleLowerCase() === countryName.toLocaleLowerCase()
    )
    return countryObj?.isoAlphaThree || defaultCode
  }

  return defaultCode
}
